import React, { useContext } from 'react'
import { AuthContext } from './AuthProvider'
import { Link } from 'react-router-dom'

const RequreAuth = ({ children }) => {

  const { token } = useContext(AuthContext)

  if (token) return children
  else return<h1>Please <Link to = "/login">login</Link> to access this page</h1>

}


export default RequreAuth